import React, { Fragment, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import get from 'lodash/get';
import { areCookiesEnabled } from '../../../utils/cookies';
import { GlobalSettingsContext } from '../../../contexts/globalSettings';
import Panel from '../../Panel/Panel';
import { Details } from '../../../components';
import styled from 'styled-components';

const GeoPanel = styled.div`
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  column-gap: 10px;
`;

const MainTab = () => {
  const { info, setInfo } = useContext(GlobalSettingsContext);
  const { REACT_APP_IPIFY_KEY } = process.env;
  const [browserWindow, setBrowserWindow] = useState(undefined);
  const [browserNavigator, setBrowserNavigator] = useState(undefined);
  const [browserDocument, setBrowserDocument] = useState(undefined);
  const [geolocation, setGeolocation] = useState(undefined);

  useEffect(() => {
    setBrowserWindow(window);
    setBrowserNavigator(navigator);
    setBrowserDocument(document);
  }, [])
    
  const fetchGeolocationData = () => {
    setGeolocation('loading');
    navigator.geolocation.getCurrentPosition(
      (e) => {
        // success
        setGeolocation(e);
      },
      (e) => {
        // error
        console.log('Geolocation Error', e)
        setGeolocation('failed');
      },
      { timeout: 30000 }
    );
  }

  const fetchBrowserItems = () => {
    const toInclude = [
      'userAgent',
      'vendor',
      'language'
    ];
    return toInclude.map(item => ({
      name: item,
      value: browserNavigator[item]
    }));
  }

  const fetchBrowserFeatures = () => {
    const features = [];

    // Check Cookies enabled
    features.push({
      name: 'Cookies Enabled?',
      value: areCookiesEnabled() ? `✅` : `🚫`
    });

    return features;
  }

  return (
    <div>
      {browserNavigator && (
        <Panel
          heading="Browser Info"
          items={fetchBrowserItems()}
        />
      )}
      <Panel
        heading="Browser Features"
        items={fetchBrowserFeatures()}
      />

      <Details
        summary={`Geolocation Info`}
      >
        {!geolocation && (
          <button onClick={fetchGeolocationData}>Fetch Geolocation Info</button>
        )}
        {geolocation === 'loading' && (
          <img alt="globe spin" src="http://img-cdn.inc.com/image/upload/v1638312423/ogv7g1lmvqg6skuibpfu.gif" />
        )}
        {geolocation && geolocation !== 'loading' && geolocation !== 'failed' && (
          <GeoPanel>
            <div className="geolocation__map">
              <iframe 
                title="user-geo-map"
                width="200" 
                height="200" 
                frameBorder="0" 
                scrolling="no" 
                marginHeight="0" 
                marginWidth="0" 
                src={`https://maps.google.com/maps?q=${get(geolocation, 'coords.latitude')},${get(geolocation, 'coords.longitude')}&z=14&output=embed`}
              />
            </div>
            <ul className="geolocation__data">
              <li><strong>Latitude:</strong> {get(geolocation, 'coords.latitude')}</li>
              <li><strong>Longitude:</strong> {get(geolocation, 'coords.longitude')}</li>
            </ul>
          </GeoPanel>
        )}
      </Details>
    </div>
  )
}

export default MainTab;